var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require('../images/minci-feder-aei.png'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }